import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "assets/icons/search.svg";
import DownIcon from "assets/icons/down.svg";
import { NavLink, useNavigate , useLocation } from "react-router-dom";
import ShopByDepartment from "../../NavigationBar/ShopByDepartment";
import StoreLocation from "components/Header/MainHeader/StoreLocation";
import {
  updateSearchText,
  getSearchResultList,
} from "redux/actions";
import useOnClickOutside from "hooks/useOnClickOutside";
import SearchDropdown from "../SearchProducts/SearchDropdown";
import { getLocalStorageValue } from "config/helper";
import _ from "lodash";
import "./home-mobile-sidebar.scss";

const MobileSidebar = (props) => {
  const { onClose } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const refSearchDropdown = useRef();
  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");

  const [isShowSearchDropdown, setIsShowSearchDropdown] = useState(false);

  useOnClickOutside(refSearchDropdown, () => setIsShowSearchDropdown(false));

  const { searchResultList, searchResultListLoading, searchType, searchText } =
    useSelector(({ search }) => search);

  const {
    ecom_section: { allow_ecommerce = "" },
    reorder_section: { has_visible_reorder_menu },
  } = useSelector(({ common }) => common.commonDetailsData);

  const { isUserLoggedIn } = useSelector(({ user }) => user);
  const searchTypeDropDownOption = useSelector(
    ({ common }) => common.commonDetailsData.top_dropdown_section
  );

  const [searchedText, setSearchedText] = useState("");

  let ecomSearchTypeDropDownOption =
    allow_ecommerce === "0" && has_visible_reorder_menu === "0"
      ? searchTypeDropDownOption?.filter(
          (option) => option.search_type !== "products"
        )
      : searchTypeDropDownOption;

  useEffect(() => {
    setSearchedText(searchText);
  }, [searchText]); // eslint-disable-line

  const handlechange = (e) => {
    setSearchedText(e.target.value);
    if (e.target.value) {
      getSearchResult.current(e.target.value);
    }
  };

  const getSearchResult = useRef(
    _.debounce((searchedText) => {
      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        search: searchedText,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
      };
      dispatch(getSearchResultList(body));
      setIsShowSearchDropdown(true);
    }, 500)
  );

  const { sub_department = [] } = useSelector(
    ({ common }) => common.commonDetailsData.ecom_section || {}
  );

  let ecomSearchOptions = [...ecomSearchTypeDropDownOption];

  if (!!sub_department.length) {
    const updatedSubDepartment = sub_department.map((sub) => {
      return {
        ...sub,
        search_type: sub.slug,
      };
    });
    ecomSearchOptions.splice(1, 0, updatedSubDepartment);
    ecomSearchOptions = ecomSearchOptions.flat();
  } else {
    ecomSearchOptions = ecomSearchTypeDropDownOption;
  }

  const categoryNameList = ecomSearchTypeDropDownOption.map(
    (cat) => cat.search_type
  );

  const handleSearchBar = () => {
    let queryParams = `?s=${searchedText}`;
    if (categoryNameList.includes(searchType)) {
      navigate(`/search/${searchType}${queryParams}`);
    } else {
      navigate(`/departments/${searchType}${queryParams}`);
    }
    dispatch(updateSearchText(searchedText));
    onClose();
  };

  const handleSearchbox = (e) => {
    const { value } = e.target;
    if (e.key === "Enter") {
      let queryParams = `?s=${value}`;
      if (categoryNameList.includes(searchType)) {
        navigate(`/search/${searchType}${queryParams}`);
      } else {
        navigate(`/departments/${searchType}${queryParams}`);
      }
      dispatch(updateSearchText(value));
    }
    onClose();
    setIsShowSearchDropdown(true);
  };

  const onSearchChange = (keyword) => {
    let queryParams = `?s=${keyword}`;
    if (categoryNameList.includes(searchType)) {
      navigate(`/search/${searchType}${queryParams}`);
    } else {
      navigate(`/departments/${searchType}${queryParams}`);
    }
    dispatch(updateSearchText(keyword));
    onClose();
  };

  const location = useLocation();
  const hidesearch = location.pathname.includes("/catering-meal");

  return (
    <>
      {/* <div
        className={
          isMobileSidebar
            ? "mobile-sidebar mobile-sidebar-show"
            : "mobile-sidebar mobile-sidebar-hidden"
        }
      > */}
      {!hidesearch && (
      <div className="container ">
      <div className="home-product-search">
        <div className="mobile-menu">
        </div>
        <div className="search-product-bar">
          <div
            className="mobile-search-products"
            ref={refSearchDropdown}
            onClick={() => {
              setIsShowSearchDropdown(!isShowSearchDropdown);
            }}
          >
            <div className="relative-div">
              <input
                type="text"
                placeholder="Search Products"
                onChange={handlechange}
                onKeyPress={handleSearchbox}
                value={searchedText}
              />
              <div className="search-img" onClick={handleSearchBar}>
                <img src={SearchIcon} alt="SearchIcon" />
              </div>
              <div className="icon-wrapper" onClick={handleSearchBar}>
            <div className="search-text">
              <span>Search</span>
            </div>
          </div>
              {searchResultList.length ? (
                <div
                  className={
                    isShowSearchDropdown
                      ? "mobile-search-dropdown dropdown-show"
                      : "mobile-search-dropdown dropdown-hidden"
                  }
                >
                  <div className="list-menu">
                    <ul>
                      {searchResultList.map((product) => {
                        return (
                          <SearchDropdown
                            key={product.keyword_id}
                            productKeyWord={product}
                            onSearchChange={onSearchChange}
                            setIsShowSearchDropdown={() =>
                              setIsShowSearchDropdown(false)
                            }
                          />
                        );
                      })}
                    </ul>
                  </div>
                </div>
              ) : (
                <div
                  className={
                    isShowSearchDropdown
                      ? "search-dropdown dropdown-show"
                      : "search-dropdown dropdown-hidden"
                  }
                >
                  {!searchResultListLoading && (
                    <div className="list-menu">
                      <ul>
                        <li>No suggestions found.</li>
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      </div>
      )}

      {/* </div> */}
    </>
  );
};

export default MobileSidebar;
